// These should match up to the breakpoints defined in /Themes/Mixins
export const SCREEN_XS: number = 0;
export const SCREEN_SM: number = 600;
export const SCREEN_MD: number = 900;
export const SCREEN_LG: number = 1200;
export const SCREEN_XL: number = 1536;
